import {OAuthStore} from "../components/auth/store";
import {AccountsError, useAuth} from "../components/auth/AuthContext";
import {FullPageSpinner} from "../components/loading/Spinner";
import {Navigate} from "react-router-dom";
import {WebErrorType} from "../domain/web-errors";
import {getWakeletUrl} from "../env/env";

const defaultErrorUrl = getWakeletUrl("/accounts/error?error=server_error")

export const ErrorRedirectPage = () => {
  const {loading, error} = useAuth();
  console.log("Got an error, redirecting", error);
  if (loading) {
    return <FullPageSpinner />;
  }
  if (isCaptchaError(error)) {
    return <Navigate to="/captcha" />;
  }
  if (isCredentialAlreadyExistsError(error)) {
    return <Navigate to="/link-account/merge" />;
  }

  const errorPageUrl = OAuthStore.getRedirectUri() || defaultErrorUrl;
  let webErr = WebErrorType.ServerError.toString();
  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.get("error")) {
    webErr = searchParams.get("error") || "";
  }
  if (isAccountDisabledError(error)) {
    webErr = WebErrorType.AccountDisabled
  }

  window.location.assign(trimParams(errorPageUrl) + `?error=${webErr}`);
  return <FullPageSpinner />;
};

const isCredentialAlreadyExistsError = (error?: AccountsError) => error?.code === "auth/account-exists-with-different-credential";
const isCaptchaError = (error: AccountsError | undefined) => error && (error.code === "INVALID_CAPTCHA" || error.code === "CAPTCHA_REQUIRED");
const isAccountDisabledError = (error?: AccountsError) => error?.code === "auth/user-disabled"

export const trimParams = (href: string) => {
  const u = new URL(href);
  const path = u.pathname.replace(/\/$/, "");
  return `${u.protocol}//${u.host}${path}`;
};
